import React from 'react';
import { connect } from 'react-redux';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';
import { addParamsToUrl } from '@zapier/url-utils';

import LoadingBlock from 'app/common/components/LoadingBlock';
import SplitLoginPageWrapper from 'app/login/components/SplitLoginPageWrapper';
import { selectSelectedApis } from 'app/login/Selectors';

import WithInvitationByCode from './WithInvitationByCode';

export const mapStateToProps = (state, props) => {
  const next = RouterSelectors.getQueryParam(state, 'next');
  const selectedApis = selectSelectedApis(state);
  const path = RouterSelectors.getCurrentPathname(state);

  const isZt =
    !!next &&
    (next.includes('/zap-templates/edit/') || next.includes('template='));
  const isLogin = path.indexOf('/app/login') === 0;
  const invitationCode = RouterSelectors.getQueryParam(state, 'invitation');
  const isInvitation = !!invitationCode;
  const isTeamMemberInvitation = path.includes('/team-member/');
  const isOneService = selectedApis.length === 1;
  const isTwoService = selectedApis.length > 1;

  const topLink =
    path.indexOf('/sign-up') === 0
      ? {
          text: 'Log In',
          href: addParamsToUrl(
            '/app/login/',
            RouterSelectors.getQueryParams(state)
          ),
        }
      : {
          text: 'Sign Up',
          href: addParamsToUrl(
            '/sign-up/',
            RouterSelectors.getQueryParams(state)
          ),
        };

  return {
    invitationCode,
    isZt,
    isLogin,
    isInvitation,
    isTeamMemberInvitation,
    isOneService,
    isTwoService,
    selectedApis,
    topLink,
    ...props,
  };
};

const SplitLoginPageWrapperContainer = props => {
  return (
    <WithInvitationByCode code={props.invitationCode}>
      {invitation => {
        if (invitation.isLoading || props.isLoading) {
          return <LoadingBlock />;
        }

        return (
          <SplitLoginPageWrapper
            {...props}
            accountName={invitation.accountName}
            teamLogoUrl={invitation.teamLogoUrl}
          />
        );
      }}
    </WithInvitationByCode>
  );
};

export default connect(mapStateToProps)(SplitLoginPageWrapperContainer);
